/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import * as S from './styles';

const twelveMonthArray = new Array(12).fill(null);

const ProfitabilityTable = ({ data }) => {
  const classes = S.useStyles();
  return (
    <div>
      <h3 className={classes.title}>RENTABILIDADE HISTÓRICA</h3>
      {
        data.yearlyProfitabilities.map((currYear, yearIndex) => (
          <div key={currYear.referenceYear} className={classes.accordionContainer}>
            <S.Divider />
            <S.Accordion square defaultExpanded={yearIndex === 0}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
              >
                <Typography className={classes.accordionTitle}>
                  {`Retorno mensal ${currYear.referenceYear}`}
                </Typography>
              </AccordionSummary>
              <TableContainer>
                <Table aria-label="Tabela de rentabilidade">
                  <TableHead>
                    <TableRow>
                      <S.StyledTableCell />
                      <S.StyledTableCell>JAN</S.StyledTableCell>
                      <S.StyledTableCell>FEV</S.StyledTableCell>
                      <S.StyledTableCell>MAR</S.StyledTableCell>
                      <S.StyledTableCell>ABR</S.StyledTableCell>
                      <S.StyledTableCell>MAI</S.StyledTableCell>
                      <S.StyledTableCell>JUN</S.StyledTableCell>
                      <S.StyledTableCell>JUL</S.StyledTableCell>
                      <S.StyledTableCell>AGO</S.StyledTableCell>
                      <S.StyledTableCell>SEP</S.StyledTableCell>
                      <S.StyledTableCell>OUT</S.StyledTableCell>
                      <S.StyledTableCell>NOV</S.StyledTableCell>
                      <S.StyledTableCell>DEZ</S.StyledTableCell>
                      <S.StyledTableCell>ACUMULADO</S.StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <S.StyledTableCell>{data.fundName}</S.StyledTableCell>
                      {twelveMonthArray.map((_, index) => {
                        const profitabilityInThisCurrentMonth = currYear
                          .monthlyProfitabilities.find(
                            item => new Date(item.date).getMonth() === index,
                          );
                        const cellData = profitabilityInThisCurrentMonth
                          ? `${profitabilityInThisCurrentMonth.profitabilityFund.toFixed(2)}%`
                          : '-';
                        return (
                          <S.StyledTableCell key={`fund-${index}`}>
                            {cellData}
                          </S.StyledTableCell>
                        );
                      })}
                      <S.StyledTableCell>
                        {`${currYear.acumulatedProfitabilityFund.toFixed(2)}%`}
                      </S.StyledTableCell>
                    </TableRow>
                    <TableRow>
                      <S.StyledTableCell>{data.benchmarkName}</S.StyledTableCell>
                      {twelveMonthArray.map((_, index) => {
                        const profitabilityInThisCurrentMonth = currYear
                          .monthlyProfitabilities.find(
                            item => new Date(item.date).getMonth() === index,
                          );
                        const cellData = profitabilityInThisCurrentMonth
                        && profitabilityInThisCurrentMonth.profitabilityBenchmark
                          ? `${profitabilityInThisCurrentMonth
                            .profitabilityBenchmark.toFixed(2)}%`
                          : '-';
                        return (
                          <S.StyledTableCell key={`benchmark-${index}`}>
                            {cellData}
                          </S.StyledTableCell>
                        );
                      })}
                      <S.StyledTableCell>
                        {`${currYear.acumulatedProfitabilityBenchmark.toFixed(2)}%`}
                      </S.StyledTableCell>
                    </TableRow>
                  </TableBody>
                </Table>
                {yearIndex === 0 && (
                <p className={classes.referenceDate}>
                  {`Data de referência:
                      ${new Intl.DateTimeFormat('pt-BR')
                    .format(new Date(data.lastReferenceDate))
                      }`}
                </p>
                )}
              </TableContainer>
            </S.Accordion>
          </div>
        ))
      }
    </div>
  );
};

ProfitabilityTable.propTypes = {
  data: PropTypes.shape({}).isRequired,
};

export default ProfitabilityTable;
